export default {"src":"/_next/static/media/trash-icon.017aba5c.svg","height":23,"width":19};